import * as notificationActionTypes
  from "../features/common/GlobalNotification/actions/action-types";

import * as driverProfileActionTypes
  from "../features/dashboard/actions/action-types";


const crossCutReducer = function(state, action) {
  switch (action.type) {
    // Update flag in insights when notification is delete
    case `${notificationActionTypes.UPDATE_INSIGHTS_AFTER_GLOBAL_NOTIFICATION_DELETE}`: {
      let insights = Object.assign({}, state.insights);
      insights.refreshContentNotificationUpdate = { update: true };
      return Object.assign({}, state, {
        insights: insights
      });
    }

    case `${driverProfileActionTypes.SET_INSIGHTS_COUNTRY_COSTCENTER}`: {
      let insightsUpdateFromDriverProfile = Object.assign({}, state.insights);
      insightsUpdateFromDriverProfile.country = action.data[0];
      insightsUpdateFromDriverProfile.costcenter = action.data[1];
      return Object.assign({}, state, {
        insights: insightsUpdateFromDriverProfile
      });
    }
      
    default:
      return state;
  }
};

export default crossCutReducer;



// WEBPACK FOOTER //
// ./src/reducer/CrossCutReducer.js